import { Head, Link } from "@inertiajs/react"
import { PublicShell } from "@/components/PublicShell"

export default function DonationCancel() {
  return (
    <>
      <Head title="Donation cancelled">
        <meta name="description" content="Your donation was not completed." />
        <meta property="og:title" content="Donation cancelled" />
        <meta property="og:description" content="Your donation was not completed." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Head>
      <PublicShell>
        <div className="max-w-md mx-auto px-4 py-16 text-center">
          <h1 className="mb-3">Donation cancelled</h1>
          <p className="text-stone-600 dark:text-stone-400 mb-8">
            No payment was taken. If you changed your mind, you're welcome to try again any time.
          </p>
          <Link href="/donate" className="underline text-sm">Back to donate</Link>
        </div>
      </PublicShell>
    </>
  )
}
